import { render, staticRenderFns } from "./CoreItemOne.vue?vue&type=template&id=c7816018&scoped=true"
import script from "./CoreItemOne.vue?vue&type=script&lang=js"
export * from "./CoreItemOne.vue?vue&type=script&lang=js"
import style0 from "./CoreItemOne.vue?vue&type=style&index=0&id=c7816018&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7816018",
  null
  
)

export default component.exports